import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const tagsV3Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Tags element to v3 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'tags'>): void => {
    if (props?.style?.general?.title && !props?.content?.title?.iconColor) {
      const currentColor = props.style.general.title.color1;
      props.content = {
        ...props.content,
        title: {
          ...props.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
